export default import.meta.ROLLDOWN_FILE_URL_IJRyAvm4BZECTcyS$rar3A